import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/anatomy/libs/singleChoiceStyles'
import { OptionType } from '~/shared/constants/commonConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTION_KEYS = [
  { key: 'casual', i18nLabel: 'first', i18nAdditional: 'firstAdditional' },
  { key: 'regular', i18nLabel: 'second', i18nAdditional: 'secondAdditional' },
  { key: 'serious', i18nLabel: 'third', i18nAdditional: 'thirdAdditional' },
  {
    key: 'determined',
    i18nLabel: 'fourth',
    i18nAdditional: 'fourthAdditional',
  },
] as const

const DailyGoalAnatomy = ({ pageId, nextPagePath }: TPageProps) => {
  const { t } = useTranslation()
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: `Let's set your daily goal`,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans i18nKey="onboarding.quizSingleChoice.dailyGoal.title" />
          </S.Question>

          <S.Subtitle $isTextLeft>
            <Trans i18nKey="onboarding.quizSingleChoice.dailyGoal.subtitle" />
          </S.Subtitle>
        </div>

        <S.OptionsBottomWrapper>
          {OPTION_KEYS.map(({ key, i18nLabel, i18nAdditional }, index) => (
            <S.StyledOption
              $withAdditionalValue
              key={key}
              $index={index}
              type={OptionType.RADIO}
              value={key}
              name="dailyGoal"
              checked={answer === key}
              disabled={isAnswersDisabled}
              onChange={(optionValue) => {
                setAnswer(optionValue)
                handleChange(optionValue, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              <S.Value>
                {t(
                  `onboarding.quizSingleChoice.dailyGoal.options.${i18nLabel}`,
                )}
              </S.Value>

              <S.AdditionalValue>
                {t(
                  `onboarding.quizSingleChoice.dailyGoal.options.${i18nAdditional}`,
                )}
              </S.AdditionalValue>
            </S.StyledOption>
          ))}
        </S.OptionsBottomWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default DailyGoalAnatomy
